// extracted by mini-css-extract-plugin
module.exports = {"container":"Header_container__3i5Dp","titleContainer":"Header_titleContainer__1X6sY","title":"Header_title__1D5M8","actionContainer":"Header_actionContainer___EVB-"};